import { Loader } from '@busybusy/webapp-react-ui';
import { useLoaderState } from 'contexts';

export default function ConnectedLoader() {
  const [props] = useLoaderState();
  return <Loader {...props} />;
}
